import * as API from '../../_api';
import * as Sentry from '@sentry/vue';

// @ts-ignore
export const addHosts = async ({commit, dispatch}, {id, hosts}) => {
  try {
    await API.addHosts(id, hosts);
    return true;
  } catch (ex: any) {
    Sentry.captureException(ex);
    dispatch('common/snackbar/error', 'Fatal Error. Please try again later', {root: true});
    return false;
  }
};

// @ts-ignore
export const readHosts = async ({commit, dispatch}, {id}) => {
  try {
    const hosts = await API.readHosts(id);
    commit('setHosts', hosts);
    return true;
  } catch (ex: any) {
    Sentry.captureException(ex);
    dispatch('common/snackbar/error', 'Fatal Error. Please try again later', {root: true});
    return false;
  }
};

// @ts-ignore
export const removeHost = async ({commit, dispatch}, {id, eventHostId}) => {
  try {
    await API.removeHosts(id, eventHostId);
    return true;
  } catch (ex: any) {
    Sentry.captureException(ex);
    dispatch('common/snackbar/error', 'Fatal Error. Please try again later', {root: true});
    return false;
  }
};
